import React from "react";
import Select from "react-select";
import { Colors } from "../../utilities/colors";
import { AutoSizer, List } from "react-virtualized";

import { components } from "react-select";

// const CheckboxOption = (props) => {
//     return (
//       <components.Option {...props}>
//         <input
//           type="checkbox"
//           checked={props.isSelected}
//           onChange={() => {}}
//           style={{ marginRight: 10 }}
//         />
//         <label>{props.label}</label>
//       </components.Option>
//     );
//   };
const CheckboxOption = (props) => {
    const {
      isSelected,
      label,
      innerRef,
      innerProps,
    } = props;
  
    return (
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "8px 12px",
          cursor: "pointer",
          backgroundColor: props.isFocused ? "#ffe9f4" : "white",
        }}
      >
        <input
          type="checkbox"
          checked={isSelected}
          readOnly // ✅ react-select handles state
          style={{ marginRight: 10 }}
        />
        <span>{label}</span>
      </div>
    );
  };
  const MenuList = (props) => {
    const rows = props.children;
    const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
      <div key={key} style={{ ...style }}>
        {rows[index]}
      </div>
    );
  
    return (
      <AutoSizer>
        {({ width, height }) => (
          <List
            width={width}
            height={40 * Math.min(rows.length, 10)}
            rowHeight={40}
            rowCount={rows.length}
            rowRenderer={rowRenderer}
            overscanRowCount={3}
          />
        )}
      </AutoSizer>
    );
  };
class MultiSelector extends React.Component {
  customStyles = {
    dropdownIndicator: this.dropdownIndicatorStyles,
    control: (base, state) => ({
      ...base,
      padding: "5.5px 5px",
      transition: "none",
      // textTransform: "capitalize",
      width: "100%",
      background: `${Colors.inputBg}`,
      minWidth: `${!this.props.minWidth ? "234px" : this.props.minWidth}`,
      border: "0px",
      outline: "none",
      boxShadow: " inset 0px 0px 4px rgba(0, 0, 0, 0)",
      borderRadius: "128px",
      "&:hover": {
        boxShadow: "0 0 0 1px #ff60b1",
        borderColor: "#ff60b1",
      },
    }),
    menu: (base) => ({
      ...base,
      marginTop: "0px",
      outline: "none",
      zIndex: "3",
      // textTransform: "capitalize",
      border: "0px solid white",
      transition: "none",
      minWidth: "234px",
    }),
    menuList: (base) => ({
      ...base,
      color: "#575757;",
      fontSize: "12px",
      minWidth: "234px",
      // textTransform: "capitalize",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: `14px`,
      fontFamily: `General Sans`,
      fontWeight: `500`,
      backgroundColor: state.isSelected ? `#D04C8D` : `transparent`,
      color: state.isSelected ? `white` : `#202020`,
      "&:hover": {
        backgroundColor: state.isSelected ? `#D04C8D` : `#FFE9F4`,
        Color: `#D04C8D`,
      },
    }),
    input: (base, state) => ({
      ...base,
      '[type="text"]': {
        color: `#575757; !important`,
      },
    }),
  };

  state = {
    selectedOption: null,
  };
  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
  };
  
  render() {
    const val = this.props.isMulti
      ? this.props.val
      : this.props.val
      ? { label: this.props.label, value: this.props.val, data: this.props }
      : undefined;

      
   
      console.log("propOptionChange",this.props.options)
    return (
      <Select
        className={this.props.classname}
        // components={{ DropdownIndicator }}
        styles={this.customStyles}
        value={val ? val : ""}
        onInputChange={this.props.inputChange}
        onChange={this.props.change}
        options={this.props.options}
        isSearchable={this.props.search ? true : false}
        isLoading={this.props.load}
        onFocus={this.props.onFocus}
        isDisabled={this.props.disable}
        placeholder={this.props.placeholder}
        hideSelectedOptions={false}
        menuIsOpen={this.props.menuIsOpen}
        components={{Option: CheckboxOption,MenuList: MenuList}}
        closeMenuOnSelect={false}
        isMulti={this.props.isMulti}
      />
    );
  }
}

export default MultiSelector;
